import { z } from 'zod';

import { IsoDateTimeSchema, UuidSchema, BooleanQueryParamSchema } from './common.js';
import { PaginationQuerySchema, paginatedResponseSchema } from './pagination.js';

/**
 * Cuisine master (B4.10). Used by MealService.
 */

export const CuisineCodeSchema = z
  .string()
  .trim()
  .regex(/^[a-z0-9-]{2,40}$/, 'Slug-style code; lowercase + dashes')
  .transform((s) => s.toLowerCase());

export const CuisineListItemSchema = z.object({
  id: UuidSchema,
  code: z.string(),
  name: z.string(),
  region: z.string().nullable(),
  isActive: z.boolean(),
  sortOrder: z.number().int(),
  createdAt: IsoDateTimeSchema,
});
export type CuisineListItem = z.infer<typeof CuisineListItemSchema>;

export const CuisineListQuerySchema = PaginationQuerySchema.extend({
  isActive: BooleanQueryParamSchema.optional(),
  region: z.string().optional(),
  includeDeleted: BooleanQueryParamSchema.optional(),
});
export type CuisineListQuery = z.infer<typeof CuisineListQuerySchema>;

export const CuisineListResponseSchema = paginatedResponseSchema(CuisineListItemSchema);
export type CuisineListResponse = z.infer<typeof CuisineListResponseSchema>;

export const CuisineDetailSchema = CuisineListItemSchema.extend({
  updatedAt: IsoDateTimeSchema,
  deletedAt: IsoDateTimeSchema.nullable(),
});
export type CuisineDetail = z.infer<typeof CuisineDetailSchema>;

const CuisineCoreFieldsSchema = z.object({
  code: CuisineCodeSchema,
  name: z.string().trim().min(1).max(120),
  region: z.string().trim().max(80).nullable().optional(),
  isActive: z.boolean().optional(),
  sortOrder: z.number().int().min(0).optional(),
});

export const CreateCuisineRequestSchema = CuisineCoreFieldsSchema;
export type CreateCuisineRequest = z.infer<typeof CreateCuisineRequestSchema>;

export const UpdateCuisineRequestSchema = CuisineCoreFieldsSchema.partial();
export type UpdateCuisineRequest = z.infer<typeof UpdateCuisineRequestSchema>;
